import script from "./MessageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageList.vue?vue&type=script&setup=true&lang=ts"

import "./MessageList.vue?vue&type=style&index=0&id=4b2e42e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b2e42e8"]])

export default __exports__